/**
 * Debug utility to log generated routes
 * Use this to troubleshoot routing issues
 */

/**
 * Recursively logs route structure
 * @param {Array} routes - Route array from generateAdminRoutes
 * @param {string} parentPath - Parent path for building full paths
 * @param {number} depth - Indentation depth
 */
export const logRoutes = (routes, parentPath = '/admin', depth = 0) => {
  const indent = '  '.repeat(depth);
  
  routes.forEach((route) => {
    const fullPath = `${parentPath}/${route.path}`;
    const hasElement = route.element !== null && route.element !== undefined;
    const childCount = route.children ? route.children.length : 0;
    
    console.log(
      `${indent}📍 ${fullPath}`,
      `[handle: ${route.handle}]`,
      hasElement ? '✅ element' : '❌ no element',
      childCount > 0 ? `(${childCount} children)` : ''
    );
    
    // Log children recursively
    if (route.children && route.children.length > 0) {
      logRoutes(route.children, fullPath, depth + 1);
    }
  });
};

/**
 * Log features tree structure
 * @param {Array} features - Features from backend API
 * @param {number} depth - Indentation depth
 */
export const logFeatures = (features, depth = 0) => {
  const indent = '  '.repeat(depth);
  
  if (!features || !Array.isArray(features)) {
    console.log('❌ Invalid features:', features);
    return;
  }
  
  features.forEach((featureWrapper) => {
    const feature = featureWrapper.node || featureWrapper;
    const children = featureWrapper.children || [];
    
    const permissions = [];
    if (feature.canView) permissions.push('view');
    if (feature.canCreate) permissions.push('create');
    if (feature.canEdit) permissions.push('edit');
    if (feature.canDelete) permissions.push('delete');
    
    console.log(
      `${indent}🔷 ${feature.handle}`,
      `[${feature.label}]`,
      `permissions: ${permissions.join(', ')}`,
      children.length > 0 ? `(${children.length} children)` : ''
    );
    
    if (children.length > 0) {
      logFeatures(children, depth + 1);
    }
  });
};

/**
 * Debug helper - call this from browser console
 * window.debugRoutes()
 */
export const setupDebug = (features, routes) => {
  globalThis.debugRoutes = () => {
    console.group('🔍 Route Debugging');
    
    console.group('📊 Features from API');
    logFeatures(features);
    console.groupEnd();
    
    console.group('🛣️ Generated Routes');
    logRoutes(routes);
    console.groupEnd();
    
    console.groupEnd();
  };
  
  console.log('✅ Debug helper loaded. Run window.debugRoutes() to see route structure');
};

export default logRoutes;
